import React from "react";
import { TeachersUIProvider } from "./TeachersUIContext";
import { TeachersCard } from "./TeachersCard";

export function TeachersPage({
  setReceipentIds
}) {
  return (
    <TeachersUIProvider>
      <TeachersCard
        setReceipentIds={setReceipentIds}
      />
    </TeachersUIProvider>
 );
}